import styled from "styled-components";

export const GamePlayMobileHeaderBarClockIconBox = styled.div`
    background-image: url("${props => props.theme.assets.images.game_frame.regulation_strip_clock_png.toString()}");
    background-size: contain;
    background-repeat: no-repeat;
    width: 10px;
    height: 10px;
    margin-right: 2px;
`